import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import OffersGroupedComponent, { type OffersGroupedIndexProps } from '@cx-modules/offers-grouped';

import { OffersClickoutGuard } from '~/modules/offers-clickout';

export const OffersGrouped = (rawProps: OffersGroupedIndexProps) => {
  const { i18n } = useTranslation();

  const props = {
    ...rawProps,
    i18n,
  } satisfies OffersGroupedIndexProps;

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <OffersClickoutGuard componentName="OffersGrouped" values={props}>
        <OffersGroupedComponent {...props} />
      </OffersClickoutGuard>
    </ErrorBoundary>
  );
};

type OffersGroupedContentContractProps = {
  [key: string]: unknown;
  geoTargeting?: boolean | string;
  repub: string;
  subdivision?: string;
  visibleOffersCount?: number;
};

export const OffersGroupedContentContractForPageTemplate = ({
  geoTargeting,
  repub,
  subdivision,
  visibleOffersCount,
  ...props
}: OffersGroupedContentContractProps) => {
  return {
    ...props,
    apiKey: ENV.OC_API_KEY[repub as keyof typeof ENV.OC_API_KEY],
    initialOffersToShow: visibleOffersCount,
    subdivisionCode: subdivision,
    theme: `oc${repub.toLowerCase()}`,
    repub,
    geoTargeting,
    ...(geoTargeting === false
      ? {
          countryCode: undefined,
          subdivisionCode: undefined,
        }
      : {}),
  };
};
